import Model from "./Model";
import moment from 'moment';
moment.locale('pt-BR');

export default class AssignmentModel extends Model {
  id: number;
  examId: number;
  createdAt: Date;
  closedAt: Date;
  numberOfReplies: number;

  static __typename: string = "Assignment";

  constructor(assignment: any, getters: any) {
    super(getters);
    this.id = assignment.id;
    this.examId = assignment.examByExamId;
    this.createdAt = new Date(assignment.createdAt);
    this.closedAt = new Date(assignment.closedAt);
    this.numberOfReplies = assignment.numberOfReplies;
  }

  start() {
      return this.createdAt ? moment(this.createdAt).format("dddd, MMMM Do YYYY, h:mm:ss a") : null;
  }

  exam() {
    return this.getters.examByExamId(this.examId);
  }

  close() {
    return this.closedAt ? moment(this.closedAt).format("dddd, MMMM Do YYYY, h:mm:ss a") : null;
  }

  raw() {
    return {
      id: this.id,
      examId: this.examId,
      createdAt: this.createdAt,
      closedAt: this.closedAt,
      repliesByAssignmentId: { totalCount: this.numberOfReplies },
      __typename: AssignmentModel.__typename
    }
  }

}